import React from 'react';

import styles from './OrderPaymentMethods.module.css'
import {Checkbox} from "../../../../ui/Filters/components/Checkbox/Checkbox.tsx";
import {cn} from "../../../../utils/cn.ts";
import {cardIcon, dolyameIcon, sbpIcon, uponDeliveryIcon} from "../../../../assets/icons/icons.ts";
import {Order} from "../../../../types/Order.interface.ts";

interface Props {
    orderOffer: Order,
    paymentMethod: string,
    onMethodChange: (method: string) => void
}

export const OrderPaymentMethods: React.FC<Props> = ({onMethodChange, orderOffer, paymentMethod, }) => {
    const paymentIcons = {
        "sbp": sbpIcon,
        "dolyame": dolyameIcon,
        "card": cardIcon,
        "upon-delivery": uponDeliveryIcon,
    };

    return (<>
         <h3 className={styles.title}>Выберите способ оплаты:</h3>
        <ul className={styles.paymentMethods}>
            {
                orderOffer.accessibilityPaymentMethods.map(({type, label}) => (
                        <li
                            key={type}
                            className={cn(styles.paymentMethod, type === paymentMethod && styles.paymentMethodChosen)}
                            onClick={() => {
                                onMethodChange(type)
                            }}
                        >
                            <Checkbox viewType='radio' checked={type === paymentMethod} label={label} />
                            <img className={styles.logo} src={paymentIcons[type]} alt={label} />
                        </li>
                    ))
            }
        </ul>
    </>);
};